import * as React from 'react'
import {IconButton} from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import YouTubeIcon from "@material-ui/icons/YouTube";
import CodeIcon from "@material-ui/icons/Code";
import GetAppIcon from "@material-ui/icons/GetApp";
import styled from "styled-components"


const Main = styled.div`
  ${props => props.rightAligned === true && `
    text-align: right
  `}
`

const StyledIconButton = styled(props => <IconButton {...props} />)`
  background-color: #ff008c;
  svg{
    width: 1.25em;
    height: 1.25em;
  }
  color: #ffffff;
  margin: 4px 4px 4px 0;
  box-shadow: 0 0 16px 2px #ff008c00;
  transition: color 0.25s, background-color 0.25s, box-shadow 0.25s;
  padding: 8px;
  :hover {
    background-color: #ffffff;
    box-shadow: 0 0 16px 2px #ff008cff;
    color: #ff008c;
  }
`

const ProjectActionBar = (props) => {
    return (
        <Main rightAligned={props.rightAligned}>
            {props.data.link && (
                <StyledIconButton variant="contained" href={props.data.link} target="_blank">
                    <LanguageIcon/>
                </StyledIconButton>
            )}
            {props.data.video && (
                <StyledIconButton variant="contained" href={props.data.video} target="_blank">
                    <YouTubeIcon/>
                </StyledIconButton>
            )}
            {props.data.repo && (
                <StyledIconButton variant="contained" href={props.data.repo} target="_blank">
                    <CodeIcon/>
                </StyledIconButton>
            )}
            {props.data.release && (
                <StyledIconButton variant="contained" href={props.data.release} target="_blank">
                    <GetAppIcon/>
                </StyledIconButton>
            )}
        </Main>
    )
}

export default ProjectActionBar;